import React from "react";
import CreditCardIcon from "../../../../../../../../images/creadit-card-gray.png";
import MCashIcon from "../../../../../../../../images/m-cash-gray.png";
import BankTransferIcon from "../../../../../../../../images/bank-transfer-gray.png";
import CreditCardHighlightIcon from "../../../../../../../../images/creadit-card-yellow.png";
import BankTransferHighlightIcon from "../../../../../../../../images/bank-transfer-yellow.png";
import MCashHighlightIcon from "../../../../../../../../images/m-cash-yellow.png";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const CheckoutOptionCard = ({
  id,
  optionInfo = {},
  selectedPaymentOption,
  setSelectedPaymentOption,
}) => {
  const { t } = useTranslation();

  const getPaymentMethodIcon = (icon = "") => {
    const iconMap = {
      CREDIT_CARD: {
        default: CreditCardIcon,
        highlighted: CreditCardHighlightIcon,
      },
      BANK_TRANSFER: {
        default: BankTransferIcon,
        highlighted: BankTransferHighlightIcon,
      },
      OTHER: {
        default: MCashIcon,
        highlighted: MCashHighlightIcon,
      },
    };

    return (
      (selectedPaymentOption === id
        ? iconMap[icon]?.highlighted
        : iconMap[icon]?.default) || MCashIcon
    );
  };

  return (
    <Grid
      container
      direction="column"
      className={`checkout-option-card ${
        selectedPaymentOption === id && "checkout-option-card-selected"
      }`}
      onClick={() => setSelectedPaymentOption(id)}
    >
      <img
        src={getPaymentMethodIcon(optionInfo.icon)}
        alt="checkout-option-icon"
        style={{ width: 35 }}
      />
      <Typography variant="caption" className="checkout-option-card-txt">
        {t(optionInfo.label)}
      </Typography>
    </Grid>
  );
};

export default CheckoutOptionCard;
